export const QuestPageClaimedMobileGrid = {
	size: 100,
	gap: 1,
	name: 'QuestPageClaimedMobileGrid',
	background: {
		element: 'quest_page_main_bg',
		main: {
			height: 100
		}
	},
	padding: {
		left: 5,
		right: 5,
		top: 2,
		bottom: 2,
		portrate: {
			left: 3,
			right: 3,
			top: 2,
			bottom: 2
		}
	},
	main: [
		{
			name: 'leftgrid-claim',
			size: 100,
			type: 'PortrateGridController',
			config: {
				size: 70,
				gap: 1,
				main: [
					{
						name: 'empty',
						size: 2
					},
					{
						name: 'header-grid-claim',
						type: 'LandscapeGridController',
						size: 10,
						config: {
							size: 100,
							gap: 1,
							name: 'header-claim',
							main: [
								{
									name: 'header',
									size: 80,
									align: 'left',
									height: 80
								},
								{
									name: 'empty',
									size: 10
								},
								{
									name: 'close',
									size: 10,
									align: 'top_right',
									height: 80
								}
							]
						}
					},
					{
						name: 'empty',
						size: 1
					},
					{
						name: 'content_grid_bottom_claim',
						size: 21,
						type: 'LandscapeGridController',
						config: {
							size: 100,
							gap: 1,
							name: 'content-claim',
							main: [
								{
									name: 'quest_daily',
									size: 75,
									align: 'left_center'
								}
							]
						}
					},
					{
						name: 'content_grid_bottom',
						size: 39,
						type: 'LandscapeGridController',
						config: {
							size: 100,
							gap: 1,
							name: 'content',
							main: [
								{
									name: 'quest_claim_1',
									size: 25
								},
								{
									name: 'quest_claim_2',
									size: 25
								},
								{
									name: 'quest_claim_3',
									size: 25
								},
								{
									name: 'quest_claim_4',
									size: 25
								}
							]
						}
					},
					{
						name: 'empty',
						size: 2
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'header-grid-claim-portaite',
			type: 'LandscapeGridController',
			size: 10,
			config: {
				size: 100,
				gap: 0,
				name: 'header',
				maxWidth: 'reel',
				main: [
					{
						name: 'header',
						size: 70,
						align: 'left',
						height: 70
					},
					{
						name: 'empty',
						size: 20
					},
					{
						name: 'close',
						size: 10,
						align: 'right',
						bounds: {
							width: 60,
							height: 60
						}
					}
				]
			}
		},
		{
			name: 'quest_daily',
			size: 19,
			bounds: {
				width: 497,
				height: 133
			}
		},
		{
			name: 'quest-grid-left',
			type: 'LandscapeGridController',
			size: 34,
			config: {
				size: 100,
				gap: 1,
				name: 'quest_1',
				main: [
					{
						name: 'quest_claim_1',
						size: 50,
						align: 'right_center'
					},

					{
						name: 'quest_claim_2',
						size: 50,
						align: 'left_center'
					}
				]
			}
		},
		{
			name: 'quest-grid-right',
			type: 'LandscapeGridController',
			size: 34,
			config: {
				size: 100,
				gap: 1,
				name: 'quest_1',
				main: [
					{
						name: 'quest_claim_3',
						size: 50,
						align: 'right_center'
					},
					{
						name: 'quest_claim_4',
						size: 50,
						align: 'left_center'
					}
				]
			}
		}
	]
};
